import { ChatChannelType, type IChatConversation } from 'src/@types/chat';
import { routes } from 'src/Router/paths';
import { UserRecentFeature } from 'src/generated/graphql';

export const featureByChatType = (conversation: IChatConversation) => {
  return {
    [ChatChannelType.TEXT]: conversation.p2p
      ? UserRecentFeature.DirectMessage
      : conversation.parentId
        ? UserRecentFeature.ThreadMessage
        : UserRecentFeature.TextChannel,
    [ChatChannelType.MEET]: UserRecentFeature.VoiceChannel,
    [ChatChannelType.VOICE]: UserRecentFeature.VoiceChannel,
  };
};

export const iconByUrl: Record<string, string> = {
  [routes.dashboard.drive.root]: 'tabler:cloud',
  [routes.dashboard.drive.shared]: 'tabler:user',
  [routes.dashboard.drive.starred]: 'tabler:star',
  [routes.dashboard.drive.trash]: 'tabler:trash',
};

export const titleByUrl: Record<string, string> = {
  [routes.dashboard.drive.root]: 'header.nav_drive.my_drive',
  [routes.dashboard.drive.shared]: 'header.nav_drive.shared_with_me',
  [routes.dashboard.drive.starred]: 'header.nav_drive.star',
  [routes.dashboard.drive.trash]: 'header.nav_drive.trash',
  [routes.dashboard.docs.trash]: 'collaborate.docs.trash.title',
  [routes.dashboard.ai.root]: 'header.ai',
};

export const collaborateFeatures: Record<string, number> = {
  [UserRecentFeature.DirectMessage]: 1,
  [UserRecentFeature.ThreadMessage]: 1,
  [UserRecentFeature.TextChannel]: 1,
};
